import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { useState, useEffect } from 'react';
import useAxios from '../plugins/useAxios';
import { useNavigate } from "react-router-dom";
import { mapSite } from '../plugins/map.site';
import { ProgressSpinner } from 'primereact/progressspinner';
import { getImageUrl } from '../utils/imageHelper';
import { useParams } from "react-router-dom";

const EventScreen = () => {
    const { direction } = useParams();

    const header = () => {
        return (
            <div className="flex justify-between items-center">
                <div>
                    {selectedEvents.length > 0 && (
                        <Button
                            type="button"
                            label={`Nascondi ${selectedEvents.length} selezionati`}
                            icon="pi pi-trash"
                            className="p-button-danger mr-2"
                            onClick={confirmBatchDelete}
                        />
                    )}
                </div>
                <div className="flex">
                    <span className="p-input-icon-left mr-2">
                        <i className="pi pi-search" />
                        <InputText value={search} onChange={onSearchChange} placeholder="Cerca targa" />
                    </span>
                    <Button type="button" icon="pi pi-filter-slash" className="p-button-outlined" onClick={clearFilter} />
                </div>
            </div>
        )
    }

    const hide = (data) => {
        return (
            <div className="cursor-pointer hover:!bg-gray-200 rounded-full transition" onClick={() => confirmDelete(data)}>
                <i className="pi pi-eraser p-2" />
            </div>
        )
    }

    const confirmDelete = (event) => {
        setEventToDelete(event);
        setShowDeleteDialog(true);
    }

    const confirmBatchDelete = () => {
        if (selectedEvents.length === 0) {
            alert('Seleziona almeno un evento da nascondere');
            return;
        }
        setEventToDelete(null);
        setShowDeleteDialog(true);
    }

    const date = (data) => {
        return (
            <div>{(new Date(parseInt(data.timestamp))).toLocaleString()}</div>
        )
    }

    const image = (data) => {
        const imageUrl = getImageUrl(data.imagePath);
        return (
            <img alt="" src={imageUrl} />
        )
    }

    const navigate = useNavigate();
    const [filters, setFilters] = useState([]);
    const [search, setSearch] = useState('');
    const [events, setEvents] = useState([]);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(50);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(true);
    const [selectedEvents, setSelectedEvents] = useState([]);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [eventToDelete, setEventToDelete] = useState(null);

    const footer = `Totale di ${events ? events.length : 0} eventi.`;

    const clearFilter = () => {
        setFilters([]);
    }

    const onSearchChange = (e) => {
        setSearch(e.target.value);
        let filteredEvents = events.filter(event => event.plate.includes(search.toUpperCase()));
        setFilters(filteredEvents);
    }

    const hideEvent = async (event) => {
        try {
            await useAxios.post(`events/${event._id}/hide`);
            let filtered = events.filter(item => item._id !== event._id);
            let _filtered = filters.filter(item => item._id !== event._id);
            setEvents(filtered);
            setFilters(_filtered);
        } catch (err) {
            console.error('Error hiding event:', err);
            alert('Errore nascondendo l\'evento');
        }
    }

    const hideBatchEvents = async () => {
        try {
            const eventIds = selectedEvents.map(e => e._id);
            await useAxios.post('events/hide-batch', { event_ids: eventIds });

            let filtered = events.filter(item => !eventIds.includes(item._id));
            let _filtered = filters.filter(item => !eventIds.includes(item._id));
            setEvents(filtered);
            setFilters(_filtered);
            setSelectedEvents([]);
        } catch (err) {
            console.error('Error hiding events:', err);
            alert('Errore nascondendo gli eventi selezionati');
        }
    }

    const handleConfirmDelete = () => {
        setShowDeleteDialog(false);
        if (eventToDelete) {
            // Singolo evento
            hideEvent(eventToDelete);
        } else {
            // Batch
            hideBatchEvents();
        }
    }

    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
        const page = e.first / e.rows; 
        loadEvents(page, e.rows); 
    };

    const loadEvents = (page, pageSize) => {
        setLoading(true);
        const tagName = localStorage.getItem('site');
        useAxios.get(`events?direction=${direction}&tagName=${tagName}&page=${page}&pageSize=${pageSize}&q=${search}`)
            .then((res) => {
                setEvents(res.data.data);
                setFilters(res.data.data);
                setTotalRecords(res.data.totalRecords);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    };

    const reloadData = () => {
        setSearch('');
        setFilters([]);
        setFirst(0); 
        loadEvents(0, rows); 
    };

    useEffect(() => {
        const tagName = localStorage.getItem('site');
        if (!tagName) {
            navigate('/sites');
            return;
        }

        loadEvents(0, rows);
    }, [direction]);

    return (
        <div className="lg:p-12 p-6">
            <div className="flex justify-between items-center mb-8">
                <div className="text-3xl font-bold mb-12">{direction === 'in' ? 'Ingresso' : 'Uscita'} {mapSite(localStorage.getItem('site'))}</div>
                <Button type="button" label="Aggiorna" icon="pi pi-refresh" onClick={reloadData} className="p-button-outlined mb-4" />
            </div>

            <div className="datatable-templating">

                {loading ? (
                    <div className="flex justify-center">
                        <ProgressSpinner />
                    </div>
                ) : (
                    <DataTable
                        value={(search !== '') ? filters : events}
                        selection={selectedEvents}
                        onSelectionChange={(e) => setSelectedEvents(e.value)}
                        dataKey="_id"
                        header={header}
                        footer={footer}
                        responsiveLayout="stack"
                        paginator={true}
                        rows={rows}
                        first={first}
                        lazy
                        onPage={onPageChange}
                        totalRecords={totalRecords}
                        emptyMessage="Nessun evento trovato"
                    >
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                        <Column field="plate" header="Targa"></Column>
                        <Column field="country" header="Paese"></Column>
                        <Column field="direction" header="Direzione"></Column>
                        <Column field="timestamp" header={direction === 'in' ? "Orario d'ingresso" : "Orario d'uscita"} body={date}></Column>
                        <Column field="image" header="Immagine" body={image}></Column>
                        <Column field="id" header="Elimina" body={hide}></Column>
                    </DataTable>
                )}
            </div>

            {/* Modal Conferma Eliminazione */}
            <Dialog
                header="Conferma Eliminazione"
                visible={showDeleteDialog}
                style={{ width: '450px' }}
                onHide={() => setShowDeleteDialog(false)}
                footer={
                    <div>
                        <Button
                            label="Annulla"
                            icon="pi pi-times"
                            onClick={() => setShowDeleteDialog(false)}
                            className="p-button-text"
                        />
                        <Button
                            label="Conferma"
                            icon="pi pi-check"
                            onClick={handleConfirmDelete}
                            className="p-button-danger"
                            autoFocus
                        />
                    </div>
                }
            >
                <div className="flex align-items-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem', color: '#f59e0b' }}></i>
                    <span>
                        {eventToDelete
                            ? `Sei sicuro di voler nascondere l'evento con targa ${eventToDelete.plate}?`
                            : `Sei sicuro di voler nascondere ${selectedEvents.length} eventi selezionati?`
                        }
                    </span>
                </div>
            </Dialog>
        </div>
    );
};

export default EventScreen;
